# 
# Manage transition betweenScene
# 
# @usage SceneTraveler.to( new Scene() )
# @author David Ronai / Makiopolis.com / @Makio64 
# 

class SceneTraveler

	@currentScene 	= null
	@nextScene		= null

	@init = ()=>
		return

	@to = (scene)=>
		
		@nextScene = scene
		if @currentScene
			@currentScene.transitionOut()
			#TweenLite.to("#darker", 1, {opacity:1});
		else
			@onTransitionOutComplete()
		return

	@update = (dt)=>
		#if @currentScene
			#@currentScene.update(dt)


	@onTransitionOutComplete = ()=>
		if @currentScene
			@currentScene.dispose()
		@currentScene = @nextScene
		@currentScene.transitionIn()
		TweenLite.to("#darker", 1, {opacity:0});
		return


	@resize = ()=>
		if @currentScene
			@currentScene.resize()
		if @nextScene
			@nextScene.resize()
		return

module.exports = SceneTraveler



/** WEBPACK FOOTER **
 ** ./src/coffee/core/scenes/SceneTraveler.coffee
 **/